/** 
 * @description: 会员发送信息设置
 * @author: hwx
 */
<template>
  <div class="members_send_info_set page_content">
    <div class="timing_list" v-show="showlist">
        <div class="row row_magin_bottom">
            <button type="button" class="btn bg-orange btn-flat bigbtn" @click="add_timing_page()">设置会员生日前一天信息</button>
        </div>
        <div class="table-responsive">
            <table ref="timing_manage_table" class="table table-bordered table-hover" data-pagination="true"></table>
        </div>
    </div>
    <!--添加会员生日信息-->
    <div class="add_printer details_content" v-show="showdetail">
        <div class="page_header" style="margin:0;">{{add_header}}</div>
        <div class="memb-add-hint">设置成功后，会员生日前一天系统会自动发送信息给对应门店会员</div>
        <div class="row rowpadding">
            <label class="col-md-1 control-label" style="width: 110px;">门店:</label>
            <div class="col-md-4">
                <input class="form-control input-readonly" placeholder="请选择门店" v-model="shop_sel_name" ref="shop_sel_name" @click="shop_data_fun($event)" readonly="readonly">
                <!-- <span class="selection_clear" @click="clear_input('shop_sel_name')">×</span> -->
                <span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
            </div>
        </div>
        <div class="row rowpadding">
            <label class="col-md-1 control-label" style="width: 110px;">信息内容:</label>
            <div class="col-md-4">
              <div contenteditable="true" class="form-control memb-birth-cont" ref="memb_send_font" id="memb_send_font"></div>
            </div>
            <div class="col-md-2 mem-bianl-insert">
                <h5>点击插入变量</h5>
              <!-- <ul>
                <li id="membClk" @click="addBianl('1', '会员微信昵称')">1、会员微信昵称</li>
                <li id="membClk" @click="addBianl('2', '门店名称')">2、门店名称</li>
                <li id="membClk" @click="addBianl('3', '门店电话')">3、门店电话</li>
              </ul> -->
                <button id="membClk" @click="addBianl('1', '会员微信昵称')">1、会员微信昵称</button>
                <button id="membClk" @click="addBianl('2', '门店名称')">2、门店名称</button>
                <button id="membClk" @click="addBianl('3', '门店电话')">3、门店电话</button>
            </div>
        </div>
        <div class="row rowpadding">
            <label class="col-md-1 control-label" style="width: 110px;">发送消息:</label>
            <div class="col-md-4">
                <input class="form-control input-readonly" placeholder="请选择发送平台" value="微信消息" disabled>
                <!-- <span class="selection_clear" @click="clear_input('memb_send_pf')">×</span>
                <span class="printer_arrow" role="presentation"><b role="presentation"></b></span> -->
            </div>
        </div>
        <div class="row" style="padding-top: 30px;">
            <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun(status)">返回</button>
            <button type="button" class="btn btn-flat btn-middle btn-orange"style="margin-left: 40px;" @click="add_menb(status)">保存</button>
        </div>
    </div>
    <!-- 门店选择 -->
    <div class="ele-hide" ref="shop_list_wrap">
        <div class="goods_checkboxdiv">
            <ul class="roomarea">
                <li v-for="item in shop_checkboxdata">
                    <input type="checkbox" name="shop_area" v-model='shop_checkboxModel' :value="item.shop_id">
                    <span>{{item.shop_name}}</span>
                </li>
                <div style="clear:both;"></div>
            </ul>
        </div>
    </div>
    <!--会员生日前一天信息详情-->
    <div class="printer_detail details_content" v-show="showonlydetail">
        <div class="page_header" style="margin: 0px;">会员生日前一天信息</div>
        <div class="memb-add-hint">设置成功后，会员生日前一天系统会自动发送信息给对应门店会员</div>
        <div class="row rowpadding printer_detail_row">
            <label class="col-md-1 control-label" style="width: 120px;">门店：</label>
            <div class="col-md-5">{{theMemb.shop_name}}</div>
        </div>
        <div class="row rowpadding printer_detail_row">
            <label class="col-md-1 control-label" style="width: 120px;">信息内容：</label>
            <div class="col-md-5" ref="theMembCon"></div>
        </div>
        <div class="row rowpadding printer_detail_row">
            <label class="col-md-1 control-label" style="width: 120px;">发送消息：</label>
            <div class="col-md-5">{{theMemb.type}}</div>
        </div>
        <div class="row" style="padding-top: 30px;">
            <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backFun(3)">返回</button>
        </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  export default {
    name: 'members_send_info_set',
    data() {
      return {
        showlist:true,
        showdetail:false,
        showonlydetail:false,
        status:1,
        theTiming: {
          type: Object
        },
        room_type_name:"",
        initBoxData: "",
        selectshopname:"",
        selectshopid:"",
        timing_room_type:"",
        selectdata:[],
        add_header:"会员生日前一天信息",
        shop_sel_name: "",
        shop_checkboxdata:[],
        shop_checkboxModel:[],
        validity_date_name:"",
        memb_birth_cont:"",

        theMemb: {
          type: Object
        },
        membId: '',
        time_cost_price:"",
        vip_cost_price:"",
        lowest_cost_price:"",
        viplowest_cost_price:"",
        intertemporal:-1
      }
    },
    components: {
    },
    watch: {
        
    },
    mounted: function() {
        this.innitable();
    },
    methods: {
        // 点击选择门店
        shop_data_fun:function(e) {
            let _this = this;
            _this.getshopdata();
            _this.shop_sel_name = "";
            layer.confirm('', {
                skin: 'add_printer_area',
                type: 1,
                btn: ['确定', '取消'], //按钮
                title: ['门店', true],
                area: ['300px', ''], //宽高
                content:$(_this.$refs.shop_list_wrap),
            }, function() {
                var texts = [];
                _this.shop_checkboxdata.forEach(function(item) {
                    _this.shop_checkboxModel.forEach(function(item2) {
                        if(item.shop_id == item2){
                            texts.push(item.shop_name);
                        }
                    });
                });
                _this.shop_sel_name = texts.join(",");
                layer.closeAll();
            });
        },
        // 门店数据
        getshopdata:function() {
            var _this = this;
            var datas = {
                "header": Vue.request_header,
                "request": {
                    "param": {}
                },
                "comment": ""
            };
            datas = JSON.stringify(datas);
            $.ajax({
                type: "POST",
                dataType: "json",
                url: Vue.ctUrl+"Setting/getVipBlessShopList",
                crossDomain: true,
                xhrFields: {
                    withCredentials: true
                },
                data: datas,
                success: function(data) {
                    if(data['response']['result_code'] == "true") {
                        _this.shop_checkboxdata = data['response']['result'];
                    } else {
                        Vue.timeoutfun(data.response.result_status,_this);
                        layer.msg(data["response"]["error_msg"]);
                    }
                },
                error: function(err) {}
            });
        },
      innitable: function() {
            var _this=this;
            var actionEvents={
              'click .update': function(e, value, row, index) {
                    // _this.initi_add_shop_name();
                    _this.status=2;
                    _this.getMembDetail(row.id,'update');
                    _this.showlist=false;
                    _this.showdetail=true;
                    _this.showonlydetail=false;
                    _this.add_header="修改会员生日前一天信息";
                    _this.membId = row.id;
              },
             'click .detail': function(e, value, row, index) {
                    _this.showlist=false;
                    _this.showdetail=false;
                    _this.showonlydetail=true;
                    _this.status=3;
                    _this.getMembDetail(row.id, '');
              }
            };
            $(this.$refs.timing_manage_table).bootstrapTable({
              pageSize: 10,
              pageList: [],
              ajax: function(params) {
                _this.gettiminglistdata(params);
              },
              sidePagination: "server",
              pagination: true,
              columns: [
              {
                width: "25%",
                field: "shop_name",
                title: "门店"
              }, {
                width: "25%",
                field: "content",
                title: "信息内容"
              }, {
                width: "25%",
                field: "type",
                title: "发送消息"
              }, {
                width: "25%",
                title: "操作",
                events: actionEvents,
                formatter: _this.actionFormatter
              }],
            });
      },
      // 添加变量
      addBianl: function(num, name) {
          var _this = this;
          let ele = '<span contenteditable="false" class="txt-col">'+ name +'</span>&nbsp;';

          var dthis = $("#memb_send_font")[0]; // 要插入内容的某个div,在标准浏览器中 无需这句话
          var sel, range;
          if (window.getSelection) {    
              // IE9 and non-IE    
              sel = window.getSelection();    
              if(sel.getRangeAt && sel.rangeCount) {
                  range = sel.getRangeAt(0);
                  range.deleteContents();
                  var el = document.createElement('div');    
                  el.innerHTML = ele;
                  var frag = document.createDocumentFragment(), node, lastNode;    
                  while ( (node = el.firstChild) ) {
                      lastNode = frag.appendChild(node);    
                  }
                  range.insertNode(frag);    
                  if (lastNode) {    
                      range = range.cloneRange();    
                      range.setStartAfter(lastNode);    
                      range.collapse(true);    
                      sel.removeAllRanges();    
                      sel.addRange(range);    
                  }    
              }    
          } else if(document.selection && document.selection.type !='Control') {            
              $(dthis).focus(); // 在非标准浏览器中 要先让你需要插入html的div 获得焦点    
              ierange = document.selection.createRange(); // 获取光标位置    
              ierange.pasteHTML(ele);    // 在光标位置插入html 如果只是插入text 则就是fus.text="..."    
              $(dthis).focus();
          }
      },
      // 添加/修改保存
      add_menb: function(status) {
          var _this = this;
          let shop_id = [],
              content = $.trim($(_this.$refs.memb_send_font).text());
          for( var i in _this.shop_checkboxModel ){
              shop_id.push(_this.shop_checkboxModel[i]);
          }
          content = content.replace(/(会员微信昵称|门店名称|门店电话)/g, function($0, $1) {
              return {
                  "会员微信昵称": "{1}",
                  "门店名称": "{2}",
                  "门店电话": "{3}"
              }[$1];
          });
          let id = "";
          if(status == "2") {
              id = _this.membId;
              // datas["request"]["param"]["id"] = this.theBrinter.id;
          }
          var datas = {
              "header": Vue.request_header,
              "request": {
                  "param": {
                      "id": id,
                      "shop_id": shop_id,
                      "content": content,
                      "type": '1'
                  }
              },
              "comment": ""
          };
          datas = JSON.stringify(datas);
          $.ajax({
              type: "POST",
              dataType: "json",
              url: Vue.ctUrl+"Setting/setVipBless",
              crossDomain: true,
              xhrFields: {
                  withCredentials: true
              },
              data: datas,
              success: function(data) {
                  if(data['response']['result_code'] == "true"){
                      layer.msg(data["response"]["error_msg"]);
                      _this.showlist = true;
                      _this.showdetail = false;
                      $(_this.$refs.timing_manage_table).bootstrapTable("destroy");
                      _this.innitable();
                  } else {
                      Vue.timeoutfun(data.response.result_status,_this);
                      layer.msg(data["response"]["error_msg"]);
                  }
              },
              error: function(err) {}
          });
      },
      // 详情
      getMembDetail: function(id, type) {
          var _this = this;
          var datas = {
              "header": Vue.request_header,
              "request": {
                  "param": {
                      "id": id
                  }
              },
              "comment": ""
          };
          datas = JSON.stringify(datas);
          $.ajax({
              type: "POST",
              dataType: "json",
              url: Vue.ctUrl+"Setting/getVipBlessDetail",
              crossDomain: true,
              xhrFields: {
                  withCredentials: true
              },
              data: datas,
              success: function(data) {
                  if(data['response']['result_code'] == "true"){
                      let result = data['response']['result'];
                      _this.theMemb = result;
                      let theMembCon = _this.theMemb.content;
                      theMembCon = theMembCon.replace(/(\{1\}|\{2\}|\{3\})/g, function($0, $1) {
                          return {
                              "{1}": "会员微信昵称",
                              "{2}": "门店名称",
                              "{3}": "门店电话"
                          }[$1];
                      });
                      $(_this.$refs.theMembCon).text(theMembCon);
                      
                      if(type == "update") {
                          $(_this.$refs.shop_sel_name).prop("disabled", true);
                          // $(_this.$refs.add_shop_name).val(datas.shop_id).trigger("change");
                          _this.shop_sel_name = result.shop_name;
                          let cgMembTxts = result.content;
                          cgMembTxts = cgMembTxts.replace(/(\{1\}|\{2\}|\{3\})/g, function($0, $1) {
                              return {
                                  "{1}": "<span contenteditable='false' class='txt-col'>会员微信昵称</span>",
                                  "{2}": "<span contenteditable='false' class='txt-col'>门店名称</span>",
                                  "{3}": "<span contenteditable='false' class='txt-col'>门店电话</span>"
                              }[$1];
                          });

                          $(_this.$refs.memb_send_font).html(cgMembTxts);
                      }
                  } else {
                      Vue.timeoutfun(data.response.result_status,_this);
                      layer.msg(data["response"]["error_msg"]);
                  }
              },
              error: function(err) {}
          });
      },
      // // 退格键
      // txtDel: function(e) {
      //     if(e.keyCode == 8){  
      //         console.log(123);
      //         // 光标定位
      //         var obj = document.getElementById('memb_send_font');
      //         if(window.getSelection) { // ie11 10 9 ff safari
      //             obj.focus(); // 解决ff不获取焦点无法定位问题
      //             var range = window.getSelection(); // 创建range
      //             range.selectAllChildren(obj); // range 选择obj下所有子内容
      //             range.collapseToEnd(); // 光标移至最后
      //         } else if(document.selection) { // ie10 9 8 7 6 5
      //             var range = document.selection.createRange(); // 创建选择对象
      //             //var range = document.body.createTextRange();
      //             range.moveToElementText(obj); // range定位到obj
      //             range.collapse(false); // 光标移至最后
      //             range.select();
      //         }
      //     }
      // },


      //操作列格式化
      actionFormatter: function(value, row, index) {
          return [
            '<div class="orange-text">',
            '<a class="update">修改</a>',
            '<a class="detail">&nbsp;&nbsp;&nbsp;&nbsp;详情</a></div>'
          ].join('');
      },
      gettiminglistdata : function(params) {
          var pageNumber=1;
          var _this=this;
          if (params.data.offset != 0) {
            pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
          }
          var layIndex = layer.load(0, {
              shade: [0.1, '#ececec']
          });
          var goods_name=this.goods_name;
          var datas = {
            "header": Vue.request_header,
            "request": {
              "param": {
                "page": pageNumber,
                "page_size": "10"
              }
            },
            "comment": ""
          };
          datas = JSON.stringify(datas);
          $.ajax({
            type: "POST",
            dataType: "json",
            url: Vue.ctUrl+"Setting/getVipBlessList",
            crossDomain: true,
            xhrFields: {
              withCredentials: true
            },
            data: datas,
            success: function(data) {
              if(data['response']['result_code']=="true"){
                params.success({
                  total: data['response']['result']['count'],
                  rows: data['response']['result']['data']
                });
              } else {
                Vue.timeoutfun(data.response.result_status,_this);
                layer.msg(data["response"]["error_msg"]);
                params.success({
                  total: 0,
                  rows: []
                });
              }
              layer.close(layIndex);
            },
            error: function(err) {
              layer.close(layIndex);
            }
          });
      },
      add_timing_page: function(params) {
        this.showlist=false;
        this.showdetail=true;
        this.showonlydetail=false;
        this.timing_room_type="";
        $(this.$refs.add_shop_name).prop("disabled", false);
        $(this.$refs.timing_room_type).addClass("canselect");
        this.shop_checkboxdata = [];
        this.shop_checkboxModel = [];
      this.time_cost_price="";
      this.vip_cost_price="";
      this.lowest_cost_price="";
      this.viplowest_cost_price="";
            $(this.$refs.shop_sel_name).prop("disabled", false);
            this.shop_sel_name = "";

            this.status=1;
            this.add_header="会员生日前一天信息";
            $(this.$refs.memb_send_font).html('<span contenteditable="false" class="txt-col">会员微信昵称</span>&nbsp;您好，在您生日到来之际<span contenteditable="false" class="txt-col">门店名称</span>&nbsp;全体员工送上真诚的祝福，生日当天来欢唱为您免费布置包房。预约：<span contenteditable="false" class="txt-col">门店电话</span>&nbsp;。');
      },
      //返回
      backFun:function(mark){
        this.showonlydetail=false;
        this.showdetail=false;
        this.showlist=true;
        (mark==1)?$(this.$refs.timing_manage_table).bootstrapTable('refreshOptions',{pageNumber:1}): (mark==3)?"":$(this.$refs.timing_manage_table).bootstrapTable('refresh');
        },
      //修改页的提示语
      hint_language:function(e) {
        var contents="<span class='dots'>·</span>"+$(e.currentTarget).attr("titles");
        layer.tips(contents,$(e.currentTarget),{
            skin: 'hint_language_tip',
            tips: [2, '#fff'],
            time: 2000000,
        });
      },
      //关闭提示语
      close_hint_language:function() {
       layer.closeAll('tips');
      },
   }
}
</script>
<style lang="less">
  .members_send_info_set {
      .layer-repetition{
    .layui-layer-title{
            padding:0px;
    }
    .tip{
      text-align: center;
      color:#5e5e5e;
      font-size: 16px;
    }
    .tipcont{
      text-align: center;
      font-size: 14px;
      color:red;
    }
  }
    .row_magin_bottom{
      margin-bottom: 50px;
    }
    .control-label {
      text-align: right;
      line-height: 32px;
      font-size: 14px;
      font-weight: normal;
      color: #5e5e5e;
      padding-left: 0;
      padding-right: 0;
   }
   .bsSuggest_input {
       background: #fff!important;
   }
   .printer_arrow{
      height: 32px;
      position: absolute;
      top: 1px;
      right: 16px;
      width: 20px;
      cursor: pointer;
      b{
        border-color: #888 transparent transparent transparent;
        border-style: solid;
        border-width: 5px 4px 0 4px;
        height: 0;
        left: 50%;
        margin-left: -4px;
        margin-top: -2px;
        position: absolute;
        top: 50%;
        width: 0;
      }
   }
 .selection_clear{
      display:none;
      height: 32px;
      position: absolute;
      top: 1px;
      right: 36px;
      width: 20px;
      cursor: pointer;
      font-weight: bold;
      line-height: 32px;
  }
  .goods_checkboxdiv{
    position: relative;
    display: block;
    margin: 0 auto;
    width: 90%;
    padding: 30px 20px 20px;
  }
  .goods_checkboxdiv ul{
    border: 1px solid #e5e5e5;
    padding: 0px 30px 20px 30px;
    border-top: none;
  }
  .roomarea{
    border:none!important;
  }
  .roomarea li{
    width:100%!important;
  }
  .timing_room_type .layui-layer-btn{
    text-align: center!important;
  }
  .timing_room_type .layui-layer-btn a{
    height: 32px!important;
    line-height: 32px!important;
    padding: 0 30px!important;
    margin:0px 20px!important;
  }
  .goods_checkboxdiv li{
    width: 14.28%;
    float: left;
    height: 32px;
    line-height: 32px;
    color: #a29d9d;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
  }
  .canselect{
    background-color:#eee!important;
  }
  .printer_detail_row div{
    line-height: 32px;
    color:#7b7b7b;
    word-break: break-all;
    min-height: 32px;
    border: 1px solid #e2e0e0;
  }
  .disabled-input[disabled]{
    background-color: #eee!important;
  }


  .memb-birth-cont {
    resize: none;
    overflow: hidden;
    height: 140px !important;
  }
  .memb-add-hint {
    margin: 20px 0;
    color: #777;
  }
  .mem-bianl-insert {
    height: 140px;
    border: 1px solid #ccc;
  }
  .mem-bianl-insert button {
    margin: 0 0 6px;
    color: #3366FF;
    font-size: 14px;
    border: none;
    background: none;
  }
  .txt-col {
    color: #3366FF;
  }
}
</style>